import React, { ReactNode } from "react"
import { Paper } from "@podcastsoundboard/ps-lib/ui"

interface FilterContainerProps {
  children: ReactNode
  flexWrap?: "nowrap" | "wrap" | "wrap-reverse"
}

const FilterContainer: React.FC<FilterContainerProps> = (props) => {
  return (
    <Paper
      elevation={0}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: props.flexWrap || "nowrap",
        padding: "12px 24px",
        borderRadius: 0,
      }}
    >
      {props.children}
    </Paper>
  )
}
export default FilterContainer
